import React, { useContext, useReducer, useState } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from "react-bootstrap/Collapse";
/// Link
import { Link } from "react-router-dom";
//import { Dropdown } from "react-bootstrap";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
//import LogoutPage from './Logout';

import { ContingentMenuList, TravelAdminMenuList } from "./Menu";
import { useSelector } from "react-redux";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
    ChangeIconSidebar,
  } = useContext(ThemeContext);
  const [userType] = useState(localStorage.getItem("userType"));
  const { userType: userTypeValue } = useSelector((store) => store.auth);

  const [state, setState] = useReducer(reducer, initialState);

  let handleheartBlast = document.querySelector(".heart");
  function heartBlast() {
    return handleheartBlast.classList.toggle("heart-blast");
  }

  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  //let scrollPosition = useScrollPosition();
  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  /// Active menu

  React.useEffect(() => {}, [userType]);
  return (
    <div
      onMouseEnter={() => ChangeIconSidebar(true)}
      onMouseLeave={() => ChangeIconSidebar(false)}
      className={`dlabnav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="dlabnav-scroll">
        <ul className="metismenu" id="menu">
          {/* For travel_module_admin */}
          {userTypeValue === "travel_module_admin" &&
          Array.isArray(TravelAdminMenuList)
            ? TravelAdminMenuList.map((data, index) => (
                <li
                  key={index}
                  className={` ${
                    state.active === data.title ? "mm-active" : ""
                  }`}
                >
                  {data.content && data.content.length > 0 ? (
                    <React.Fragment>
                      <Link
                        to="#"
                        className="has-arrow"
                        onClick={() => handleMenuActive(data.title)}
                      >
                        {data.iconStyle}{" "}
                        <span className="nav-text">{data.title}</span>
                      </Link>
                      <Collapse in={state.active === data.title}>
                        <ul
                          className={`mm-collapse ${
                            state.active === data.title ? "mm-show" : ""
                          }`}
                        >
                          {data.content.map((subData, subIndex) => (
                            <li
                              key={subIndex}
                              className={`${
                                state.activeSubmenu === subData.title
                                  ? "mm-active"
                                  : ""
                              }`}
                            >
                              <Link
                                to={subData.to}
                                onClick={() =>
                                  handleSubmenuActive(subData.title)
                                }
                              >
                                {subData.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </Collapse>
                    </React.Fragment>
                  ) : (
                    <Link to={data.to}>
                      {data.iconStyle}{" "}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                  )}
                </li>
              ))
            : userTypeValue === "contingent" &&
              Array.isArray(ContingentMenuList)
            ? ContingentMenuList?.map((data, index) => (
                <li
                  key={index}
                  className={` ${
                    state.active === data.title ? "mm-active" : ""
                  }`}
                >
                  {data.content && data.content.length > 0 ? (
                    <React.Fragment>
                      <Link
                        to="#"
                        className="has-arrow"
                        onClick={() => handleMenuActive(data.title)}
                      >
                        {data.iconStyle}{" "}
                        <span className="nav-text">{data.title}</span>
                      </Link>
                      <Collapse in={state.active === data.title}>
                        <ul
                          className={`mm-collapse ${
                            state.active === data.title ? "mm-show" : ""
                          }`}
                        >
                          {data.content.map((subData, subIndex) => (
                            <li
                              key={subIndex}
                              className={`${
                                state.activeSubmenu === subData.title
                                  ? "mm-active"
                                  : ""
                              }`}
                            >
                              <Link
                                to={subData.to}
                                onClick={() =>
                                  handleSubmenuActive(subData.title)
                                }
                              >
                                {subData.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </Collapse>
                    </React.Fragment>
                  ) : (
                    <Link to={data.to}>
                      {data.iconStyle}{" "}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                  )}
                </li>
              ))
            : null}
        </ul>

        {/* <div className="side-bar-profile">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="side-bar-profile-img me-2">
              <img src={user} alt="" />
            </div>
            <div className="profile-info1">
              <h4 className="fs-18 font-w500">Levi Siregar</h4>
              <span>leviregar@mail.com</span>
            </div>
            <div className="profile-button">
              <i className="fas fa-caret-down scale5 text-light"></i>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-2 progress-info">
            <span className="fs-12">
              <i className="fas fa-star text-orange me-2"></i>Task Progress
            </span>
            <span className="fs-12">20/45</span>
          </div>
          <div className="progress default-progress">
            <div
              className="progress-bar bg-gradientf progress-animated"
              style={{ width: "45%", height: "10px" }}
              role="progressbar"
            >
              <span className="sr-only">45% Complete</span>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>
            <strong>Fillow Saas Admin</strong> © 2023 All Rights Reserved
          </p>
          <p className="fs-12">
            Made with{" "}
            <span className="heart" onClick={() => heartBlast()}></span> by
            DexignLab
          </p>
        </div> */}
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
